import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
  imports: [TranslateModule],
})
export class DividerComponent {
  @Input()
  public label = '';
  @Input() public padding = '10px';
}
